<template>
  <div>
    <div v-show="showTable">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input v-model="searchName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryOrgList()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reset()">显示所有</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" border style="width: 100%">
        <el-table-column fixed prop="id" label="ID" width="80">
        </el-table-column>
        <el-table-column fixed prop="name" label="机构名" width="300">
        </el-table-column>
        <el-table-column prop="legal_person" label="法人姓名" width="200">
        </el-table-column>
        <el-table-column prop="legal_person_phone" label="法人电话" width="150">
        </el-table-column>
        <el-table-column prop="director" label="联系人" width="150">
        </el-table-column>
        <el-table-column prop="director_phone" label="联系人电话" width="150">
        </el-table-column>
        <el-table-column prop="address" label="地址" width="250">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="200">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click.native.prevent="modify(scope.$index, tableData)" type="text" size="small">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;margin-bottom:10px" background layout="prev, pager, next" :current-page.sync="currentPage" :page-size="20" :total="totalCount">
      </el-pagination>
    </div>
    <div v-if="showModify" style="width: 400px">
      <el-form>
        <el-form-item label="机构名" :label-width="formLabelWidth">
          <el-input v-model="formModify.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" :label-width="formLabelWidth">
          <el-input v-model="formModify.legal_person" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="法人电话" :label-width="formLabelWidth">
          <el-input v-model="formModify.legal_person_phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model="formModify.director" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" :label-width="formLabelWidth">
          <el-input v-model="formModify.director_phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="formModify.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="formModify.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showModify = false; showTable = true">取 消</el-button>
        <el-button type="primary" @click="updateOrg()">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  let Base64 = require('js-base64').Base64;
  export default {
    data() {
      return {
        tableData: [],
        formModify: {
          name: '',
          legal_person: '',
          legal_person_phone: '',
          director: '',
          director_phone: '',
          address: '',
          email: ''
        },
        totalCount: 1000,
        pagesize: 20,
        currentPage: 1,
        currentOrg: '',
        showTable: true,
        showModify: false,
        formLabelWidth: '120px',
        searchName: ''
      }
    },
    methods: {
      rowClick(row, column, event) {
        console.log(row)
        this.currentOrg = row
      },
      modify(index, row) {
        console.log(index)
        this.currentOrg = row[index]
        console.log(this.currentOrg)
        let username = localStorage.getItem('username')
        if (username != "teacher") {
          this.$message.error({
            message: '当前账户非一级管理员，不支持修改证书',
            center: true
          });
          return
        }
        this.formModify.name = this.currentOrg["name"]
        this.formModify.legal_person = this.currentOrg["legal_person"]
        this.formModify.legal_person_phone = this.currentOrg["legal_person_phone"]
        this.formModify.director = this.currentOrg["director"]
        this.formModify.director_phone = this.currentOrg["director_phone"]
        this.formModify.address = this.currentOrg["address"]
        this.formModify.email = this.currentOrg["email"]
        this.showTable = false
        this.showModify = true
      },
      updateOrg() {
        let jsondata = {}
        if (this.formModify.name != this.currentOrg["name"]) {
          jsondata["name"] = this.formModify.name
        }
        if (this.formModify.legal_person != this.currentOrg["legal_person"]) {
          jsondata["legal_person"] = this.formModify.legal_person
        }
        if (this.formModify.legal_person_phone != this.currentOrg["legal_person_phone"]) {
          jsondata["legal_person_phone"] = this.formModify.legal_person_phone
        }
        if (this.formModify.director != this.currentOrg["director"]) {
          jsondata["director"] = this.formModify.director
        }
        if (this.formModify.director_phone != this.currentOrg["director_phone"]) {
          jsondata["director_phone"] = this.formModify.director_phone
        }
        if (this.formModify.address != this.currentOrg["address"]) {
          jsondata["address"] = this.formModify.address
        }
        if (this.formModify.email != this.currentOrg["email"]) {
          jsondata["email"] = this.formModify.email
        }
        console.log("patch " + this.currentOrg["id"])
        console.log(jsondata)
        this.$http
          .patch('http://120.27.221.176/backend/api/v1/basic/organization/' + this.currentOrg["id"] + '/', jsondata)
          .then(response => {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.showModify = false
            this.showTable = true
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      reset: function () {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/organization/')
          .then(response => {
            this.tableData = response.data
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      queryOrgList: function () {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/organization/name_lookup/' + this.searchName + '/')
          .then(response => {
            this.tableData = response.data
            this.currentPage = 1
            this.totalCount = response.data.length
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
    },
    mounted: function () {
      this.$http
        .get('http://120.27.221.176/backend/api/v1/basic/organization/')
        .then(response => {
          this.tableData = response.data
          this.totalCount = response.data.length
        })
        .catch(error => {
          console.log(error)
          this.$message.error({
            message: '查询失败，请重试',
            center: true
          });
        })
        .finally(() => {

        });
    }
  }
</script>
<style scoped>
  my-el-dialog {
    border: black;
    box-shadow: 0 0px 1px rgba(0, 0, 0, .3);
  }
</style>



// WEBPACK FOOTER //
// src/components/OrgManage.vue